// removed by extract-text-webpack-plugin
module.exports = {"sidebar":"_2FK_66AdzkX0IsVOKs76LK","aside":"_1OxnAxsKBfrmVNnrxdDG-E","appName":"_1opegXY-4y8m-sGaot9T4B","close":"_3SrH7bDWmnPQDMyUwjsobQ","appContainer":"_2SqPyaGFFuWZaTyStquHkQ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Sidebar/Sidebar.css
// module id = 471
// module chunks = 0